import { Link } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
import LazyLoad from "react-lazyload";

const Carpediem = () => {
  const homeMenu = [
    { label: "Latest Update", link: "/news" },
    {
      label: "Testimonials",
      link: "/testimonial",
    },

    { label: "School Calendar", link: "/calender" },
    { label: "CBSE Circulars", link: "/circular" },
    { label: "eMagazine", link: "/Magazine" },
    { label: "TAABIR Digital Dreams", link: "/digitaldreams" },
    { label: "Fortnightly School Magazine", link: "/fortnightlyMagazine" },
    { label: "Carpe Diem'22 ", link: "/carpediem" },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/banner-school.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Carpe Diem'22"
                breadEnd="Carpe Diem'22"
                breadMid="Carpe Diem'22"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Carpe Diem'22</Accordion.Header>
                  <Accordion.Body>
                    <div className="d-flex">
                      <div className="magazine">
                        <Link
                          to="https://online.anyflip.com/giovo/pjba/index.html"
                          rel="noreferrer"
                          target="_blank">
                          <LazyLoad>
                            {" "}
                            <img
                              src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/carpe-diem-1.jpg"
                              alt="Lotus Valley School, Gurgaon"
                              className="img-fluid"
                            />
                          </LazyLoad>
                          <p>The LVISG Times 1st Edition</p>
                        </Link>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Carpediem;
